export const VERSION = '4.26.0'; // x-release-please-version
